import { injectable } from 'inversify';

import * as Api from '../../constants/ApiUrlConstants'
import { IMenuModel } from '../../models/MenuItems';
import SERVICE_IDENTIFIER from '../../wires/Identifiers';
import container from '../../wires/Bootstrapper';
import { IApiService } from './ApiService';

export interface IMenuService {
    getMenu(): IMenuModel | {};
}


@injectable()
export class MenuService implements IMenuService {
    apiClient: IApiService;

    public constructor() {
        this.apiClient = container.get(SERVICE_IDENTIFIER.API_SERVICE);

    }
    async getMenu() {
        let resp: IMenuModel = await this.apiClient.getAsync<IMenuModel>(Api.Menu, null);
        return resp;
    }
}
